import { PROFESSION_OPTIONS } from '@constants/selectorsConstants';

export const PROFESSION_MAP: Record<string, string> = PROFESSION_OPTIONS.reduce(
  (acc, o) => {
    acc[o.value.trim()] = o.label;
    return acc;
  },
  {} as Record<string, string>,
);
